import { Text, VStack } from "@chakra-ui/react"

import PortalData from "#/ui-old/PortalData"

export default function MobileView() {
  return (
    <VStack px={5}>
      <VStack
        mt={-2.5}
        mb={42}
        align="start"
        spacing={0}
        fontWeight={900}
        fontFamily="riforma.heavy"
        fontSize="38px"
        lineHeight="52px"
        letterSpacing="-0.38px"
      >
        <Text as="span">Get ready for Mainnet. </Text>
        <Text as="span" color="primary.red.100">
          From a desktop.
        </Text>
      </VStack>
      <PortalData px={0} />
    </VStack>
  )
}
